import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-491a291a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-jobs" }
const _hoisted_2 = { class: "head" }
const _hoisted_3 = { class: "category-buttons" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("本日通告")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("報名成功")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("待審核")
const _hoisted_7 = { class: "body f-scroll" }
const _hoisted_8 = { class: "jobs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_JobListItemPersonal = _resolveComponent("JobListItemPersonal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_button, {
          class: "category-button",
          shape: "round",
          type: _ctx.searchForm.type === 3 ? 'primary' : '',
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setSearchFormType(3)))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_a_button, {
          class: "category-button",
          shape: "round",
          type: _ctx.searchForm.type === 2 ? 'primary' : '',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSearchFormType(2)))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_a_button, {
          class: "category-button",
          shape: "round",
          type: _ctx.searchForm.type === 1 ? 'primary' : '',
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setSearchFormType(1)))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["type"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personalJobs, (job) => {
          return (_openBlock(), _createBlock(_component_JobListItemPersonal, {
            job: job,
            personalJobType: _ctx.searchForm.type,
            key: job.id
          }, null, 8, ["job", "personalJobType"]))
        }), 128))
      ])
    ])
  ]))
}